import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getCountryCode } from '@hotjar/webapp/domains/activation/onboarding/api';

export const GEO_LOCATIOM_QUERY_KEY = 'geoLocation';

export const useGeoLocation = (): UseQueryResult<string, Error> => {
  return useQuery([GEO_LOCATIOM_QUERY_KEY], () => getCountryCode(), {
    retry: false,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};
